import { InputAdornment } from "@mui/material";
import { FlexProps } from "./Flex";
import NumberInput from "./NumberInput";

const DEFAULT_CURRENCY_SYMBOL = "$";
const BLOCKED_KEYS = ["-", "+", "e", "E"];

export type CurrencyInputProps = {
  label?: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  currencySymbol?: string;
  placeholder?: string;
  error?: string | boolean;
  required?: boolean;
  disabled?: boolean;
  min?: number;
  max?: number;
  flexprops?: FlexProps;
};

/**
 * Non-negative amount field with a currency adornment.
 *
 * @author Rajkumar Rathod
 */
const CurrencyInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  currencySymbol = DEFAULT_CURRENCY_SYMBOL,
  placeholder,
  error,
  required,
  disabled,
  min,
  max,
  flexprops,
}: CurrencyInputProps) => {
  return (
    <NumberInput
      label={label}
      error={error}
      required={required}
      min={min}
      max={max}
      flexprops={flexprops}
      blockedKeys={BLOCKED_KEYS}
      textFieldProps={{
        name,
        value,
        placeholder,
        disabled,
        onBlur,
        onChange: (event) => onChange(event.target.value),
        slotProps: {
          input: {
            startAdornment: (
              <InputAdornment position="start">{currencySymbol}</InputAdornment>
            ),
          },
        },
      }}
    />
  );
};

export default CurrencyInput;
